import { type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useMe } from "@/hooks/use-me";

export function RequireAuth({ children }: { children: ReactNode }) {

    const me = useMe();
    const location = useLocation();

    if (me.isLoading)
        return (
            <div className="min-h-screen flex items-center justify-center bg-background text-sm text-muted-foreground">
                Loading…
            </div>
        );

    if (!me.data?.user)
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;

    return <>{children}</>;
}
